import { readable, writable } from "svelte/store";
export var player = writable({
    uuid: null,
    token: null,
    locationId: null,
    positionId: null,
    fingerprint: null
});
export var user = writable({
    authenticated: false,
    profile: null,
    token: null,
    login: function () { },
    logout: function () { },
    updateToken: null,
    extendedProfile: false,
    extendedUserData: null,
    permissions: []
});
export var mediaQuery = readable({
    mql: window.matchMedia("(max-width: 800px)")
}, function (set) {
    set({ mql: window.matchMedia("(max-width: 800px)") });
});
